import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { UserList } from './type'

interface UserListState {
    userList: UserList[] | null
}

const initialState: UserListState = {
    userList: null,
}

const userListSlice = createSlice({
    name: 'users',
    initialState,
    reducers: {
        setUsersList(state, action: PayloadAction<UserList[]>) {
            state.userList = action.payload
        },
        deleteUsersList(state, action: PayloadAction<string>) {
            if (state.userList) {
                state.userList = state.userList.filter(
                    (user) => user.id !== action.payload
                )
            }
        },
    },
})

export const { setUsersList, deleteUsersList } = userListSlice.actions

export default userListSlice.reducer
